export function betaAccessPath(level: number, isAuthenticated: boolean): string {
  const destination = level === 3 ? "/service-level3-internal" : level === 1 ? "/analysis" : "/service-level2-internal";
  return isAuthenticated ? destination : `/user-registration?redirect=${encodeURIComponent(destination)}`;
}